import React from 'react';
import styled from 'styled-components';

import { Completed } from '@/assets/icons';
import { media } from '@/styles/theme';

interface INoAgents {
  title?: string;
  className?: string;
}

const NoAgents = ({ title, className }: INoAgents): React.ReactElement => (
  <Container className={className}>
    <Text>{title}</Text>
  </Container>
);

export { NoAgents };

const Container = styled.div`
  display: flex;
  justify-content: center;

  margin-top: 13px;
  margin-left: 30px;
  margin-right: 30px;
  padding-top: 20px;
  padding-bottom: 20px;
  background: #ecfdf5;

  border: 1px solid #d1fae5;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.075);
  border-radius: 8px;
`;

const Text = styled.div`
  display: flex;
  padding: 30px 30px 10px;
  text-align: center;

  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  color: #047857;

  background-image: url(${Completed});
  background-repeat: no-repeat;
  background-size: 20px 20px;
  background-position: top;

  ${media.laptop} {
    display: inline-block;
    height: 20px;
    padding: 0 0 0 29px;

    text-align: left;
    background-position: left;
  }
`;
